import Functions from '../functions';

export default class TableBase {

  constructor(dynamic_block_selector, lang) {

    this._dynamic_block_selector = dynamic_block_selector;
    this._table_selector = 'table.list';
    this._sort_link_selector = '.sorted';
    this._pagination_selector = '.pagination';
    this._pagination_link_selector = this._pagination_selector + ' a';
    this._pagination_loading_spinner_selector = this._pagination_selector + ' .loading_spinner';

    this.lang = lang;
  }

  get dynamic_block() {
    return $(this._dynamic_block_selector);
  }

  get table_element() {
    return this.dynamic_block.find(this._table_selector);
  }

  get sort_links() {
    return this.table_element.find(this._sort_link_selector);
  }

  get pagination_links() {
    return this.dynamic_block.find(this._pagination_link_selector);
  }

  get pagination_loading_spinner() {
    return this.dynamic_block.find(this._pagination_loading_spinner_selector);
  }

  init() {
    this._initTableLinks();
  };
  
  _addButtonLoadingSpinner(button) {
    Functions.addButtonLoadingSpinner(button);
  }

  _removeButtonLoadingSpinner(button) {
    Functions.removeButtonLoadingSpinner(button);
  }
  
  _initTableLinks() {
    this._initTableSortLinks();
    this._initTablePaginationLinks();
  };

  _initTableSortLinks() {

    var table = this;

    this.sort_links.click(function (event) {
      event.preventDefault();
      $.ajax({
        url: $(this).attr('href'),
        type: 'post',
        dataType: 'json',
        beforeSend: table.showLoadingBlock.bind(table),
        success: table._processGetOperationsResult.bind(table),
        complete: table.hideLoadingBlock.bind(table)
      });
      return false;
    });
  };

  showLoadingBlock() {
    this.pagination_loading_spinner.show();
  };

  hideLoadingBlock() {
    this.pagination_loading_spinner.hide();
  };

  _processGetOperationsResult(result) {

    if (!parseInt(result.status)) {
      this._processWrongResult(result);
      return;
    }

    this._reinitDynamicBlock(result.html);
  };

  _processWrongResult(result) {

    if(result.hasOwnProperty('redirect_url') && result.redirect_url.length) {
      window.location.href = result.redirect_url;
      return;
    }

    if (result.hasOwnProperty('error') && result.error.length) {
      alert(result.error);
    }
  };

  _reinitDynamicBlock(html) {
    this._updateDynamicBlock(html);
    this._initTableLinks();
  };

  _updateDynamicBlock(html) {
    this.dynamic_block.html(html);
  }

  _initTablePaginationLinks() {

    var table = this;
    var showLoadingBlock = this.showLoadingBlock;
    var _processGetOperationsResult = this._processGetOperationsResult;

    this.pagination_links.click(function (event) {
      event.preventDefault();
      $.ajax({
        url: $(this).attr('href'),
        type: 'get',
        dataType: 'json',
        beforeSend: showLoadingBlock.bind(table),
        success: _processGetOperationsResult.bind(table)
      });
      return false;
    });
  };

}



/** WEBPACK FOOTER **
 ** ./src/common/table/base.js
 **/